<template>
      <div class="hl-wid ww3 adm-list">
        <ul class="tab-like">
          <li class="head">
            <ul>
              <li class="title" v-on:click.prevent="toggleSort('title')">
                <span>Title</span>
                <a href="" class="s-inc" :class="{active: sort.title===true}"></a>
                <a href="" class="s-dec" :class="{active: sort.title===false}"></a>
              </li>
            </ul>
          </li>
          <li v-for="(item, ii) in items">
            <ul>
              <li class="title"><a href="" v-on:click.prevent="$emit('select', item)">{{ item.title }}</a></li>
              <li class="type">&nbsp;</li>
              <li class="language">&nbsp;</li>
              <li class="author">{{ (item.videos?item.videos.length:0) || "no" }} {{ (item.videos?item.videos.length:0)==1?"video":"videos" }}</li>
              <li class="date">&nbsp;</li>
              <li class="remove"><a href="" v-on:click.prevent="remove(ii)">remove</a></li>
              <a class="link-full" href="" v-on:click.prevent="$emit('select', item)"></a>
            </ul>
          </li>
        </ul>
      </div>
</template>

<script>
import api from './api';

export default {
  props: ["user"],
  data: ()=>({
    entity: "Playlist",
    items: [],
    sort: {title: null},
  }),
  computed: {
    sortedItems() {
      var items=items.slice();
      return items;
    },
  },
  created() {
    this.loadPlaylists();
  },
  methods: {
    async loadPlaylists() {
      this.items=(await api.list("Playlist", {user: this.user.id})).items;
    },
    async remove(index) {
      if (!confirm("Are you sure?"))
        return;
      await api.delete("Playlist", this.items[index].id);
      this.items.splice(index, 1);
    },
  },
}
</script>
